import { DispatchLoading, DispatchType, ResponseValid } from "domain/utils/ReactUtils";
import { AppThunk } from "base/src/utils/reducerUtil";
import { DetalhePagamentoService } from "../../../services/detalhePagamento/detalhePagamentoService";
import { DetalhePagamentoRequest } from "../../../types/detalheResgate/detalhePagamentoRequest";
import { DETALHE_PAGAMENTO, PAGAMENTO } from "domain/types/_carteira/detalhePagamento/detalhePagamento";
import { PagamentoRequest } from "../../../types/detalheResgate/pagamentoRequest";
import { PagamentoService } from "domain/services/_carteira/pagamento/pagamentoService";
import { PagamentoPixResponse, TransferenciaPixRequest } from "domain/types/_carteira/premiacao/transferenciaPixTypes";

const _DetalhePagamentoService = new DetalhePagamentoService();
const _PagamentoService = new PagamentoService();

export function GetPagamentos(request: PagamentoRequest, carteiraId: number, callback: () => void): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(PAGAMENTO, DispatchType.LOADING, 'teste'));

    const asyncResponse = await _DetalhePagamentoService.GetPagamentos(request, carteiraId);

    if (ResponseValid(asyncResponse, false, dispatch)) {

      dispatch({
        payload: asyncResponse,
        type: PAGAMENTO
      });

      callback();

      dispatch(DispatchLoading(PAGAMENTO, DispatchType.SUCCESS));
    }
  };
}

export function GetPagamentoDetalhe(request: DetalhePagamentoRequest, carteiraId: number, callback: () => void): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(DETALHE_PAGAMENTO, DispatchType.LOADING, 'teste'));

    const asyncResponse = await _DetalhePagamentoService.GetDetalhePagamento(request, carteiraId);

    if (ResponseValid(asyncResponse, false, dispatch)) {

      dispatch({
        payload: asyncResponse,
        type: DETALHE_PAGAMENTO
      });

      callback();

      dispatch(DispatchLoading(DETALHE_PAGAMENTO, DispatchType.SUCCESS));
    }
  };
}

export function GetPagamentoDetalheByExtratoID(request: DetalhePagamentoRequest, carteiraId: number, callback: () => void): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(DETALHE_PAGAMENTO, DispatchType.LOADING, 'teste'));

    const asyncResponse = await _DetalhePagamentoService.GetPagamentoDetalheByExtratoID(request, carteiraId);

    if (ResponseValid(asyncResponse, false, dispatch)) {

      dispatch({
        payload: asyncResponse,
        type: DETALHE_PAGAMENTO
      });

      callback();

      dispatch(DispatchLoading(DETALHE_PAGAMENTO, DispatchType.SUCCESS));
    }
  };
}

export function TransferirPix(
  carteiraId: number, 
  request: TransferenciaPixRequest, 
  // eslint-disable-next-line no-unused-vars
  callback: (success: boolean, response?: PagamentoPixResponse) => void
): AppThunk {
  return async () => {
    try {
      const asyncResponse = await _PagamentoService.TransferirPix(carteiraId, request);

      if (asyncResponse && !(asyncResponse instanceof Error)) {
        callback(true, asyncResponse);
      } else {
        callback(false, undefined);
      }
    } catch (error) {
      callback(false, undefined);
    }
  };
}